<template>
  <a href="#" :class="{'muted': !isActive, '!text-bc-blue': isActive}" v-if="show" @click.prevent="click">
    <aw-icon icon="share-list" class="w-5 h-5 "></aw-icon>
    {{$t('Share list %length%', {length: bcSelectedBasketStore.selected.length})}}
  </a>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcSelectedBasketStore from '@/frontapp/store/bcSelectedBasket'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import { trackEvent } from '../../gtm'

export default {
  computed: {
    show () {
      return this.$route.matched[0].name !== 'BCSharedDocument' && (this.$route.matched[0].name !== 'BCDocument' || this.bcDocumentStore.documentRev === null) && this.bcSelectedBasketStore.selected.length > 0
    },
    isActive () {
      return this.bcSelectedBasketStore.selected.length > 0
    },
    ...mapStores(useBcSelectedStore, useBcSelectedBasketStore, useBcDocumentStore),
  },
  methods: {
    click() {
      this.$formValues['frm-sharingForm-sharingForm-sharing_type:change'] = 'email'
      this.$store.commit('nette/updateControl', {
        controlName: 'sharingForm',
        data: true,
        key: 'showModal',
      })
      this.$store.commit('nette/updateControl', {
        controlName: 'sharingForm',
        data: true,
        key: 'basket',
      })
      trackEvent(this.$route.matched[0].name, 'showShareListForm')
    }
  },
}
</script>

<style lang="scss" scoped></style>
